import {
  Block,
  Button,
  CtaButton,
  Icon,
  Input,
  ListItemCell,
  Select,
  Text,
  styled,
} from "../../../seenspire-library";

export const StyledCtaButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
`;

export const Container = styled(Block)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

export const ModalTitle = styled(Text)`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color: #3a404b;
`;

export const ModalSubtitle = styled(Text)`
  font-size: 15px;
  text-align: center;
`;

export const ModalDescription = styled(Text)`
  font-size: 11px;
  text-align: center;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  margin-top: 20px;
`;

export const ModalCustomStyles = {
  content: {
    padding: "52px 60px 48px 60px",
  },
};

export const CodeContainer = styled(Block)`
  width: 100%:
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const CodeInput = styled(Input)`
  width: 42px;
  text-align: center;
  font-size: 1.5rem;
  font-size: 28px;
  font-weight: 500;
  padding: 6px; 18px;
  color: #000;
`;

export const CodeDivider = styled(Block)`
  width: 15px;
  height: 1px;
  background: #d5dbe2;
`;

export const StyledInput = styled(Input)`
  width: 100%;
  margin-top: 20px;
  padding: 16px;
`;

export const avatarStyle = {
  right: 20,
  bottom: -1,
  zIndex: 100,
  height: 34,
  width: 34,
  borderRadius: "50%",
  border: "2px solid white",
  boxShadow: "none",
};

export const ListItemCellFirst = styled(ListItemCell)`
  padding-left: 30px;
`;

export const ListItemCellLast = styled(ListItemCell)`
  padding-right: 30px;
`;

const LicenceUserBlock = styled.div`
  position: absolute !important;
  width: 210px;
  height: 50px;
  top: 0;
  right: 0;
  -webkit-transform: translateY(-216%) translateX(-0px);
  -ms-transform: translateY(-216%) translateX(-0px);
  transform: translateY(-216%) translateX(-0px);
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
`;

export const AddScreenButton = styled(CtaButton)`
  width: 170px;

  &:hover {
    width: 170px;
  }
`;

export const IconButton = styled(Button)<{ variant: "error" | "primary" }>`
  padding: 0 11px;
  max-width: 56px;
  min-height: 48px;
  min-width: unset;
  &:hover {
    background-color: ${({ theme, variant }) =>
      variant === "error" ? theme.colors.alert.base : theme.colors.cta.base};
    fill: ${({ theme }) => theme.colors.white.base};
  }
  svg {
    width: 14px !important;
    height: 14px !important;
  }

  &:hover {
    path {
      fill: ${({ theme }) => theme.colors.white.base};
    }
  }
`;

export const EmptyPlaceholderIcon = styled(Icon)`
  width: 150px;
  height: 150px;
`
export const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 16px;
`;